import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/routesInfos/28'
        },
        {
            path: '/routesInfos/:screenId',
            name: 'RoutesInformations',
            component: () => import('@/components/routes/RoutesInformationsRoute'),
            meta: {
                title: 'Routes Informations'
            }
        }
    ]
})

export default router
